import { Button } from '@plato/ui-legacy/components/ui/button';
import { PrinterIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Can } from '../../acl/can.tsx';
import { ExplorerExportDataButton } from './explorer-view-actions-export-button.tsx';

export function ExplorerViewActions() {
    return (
        <Can I="export" a="SalesReport">
            <ExplorerExportDataButton />
            <ExplorerPrintButton />
        </Can>
    );
}

function ExplorerPrintButton() {
    const { t } = useTranslation();

    return (
        <Button
            icon={PrinterIcon}
            variant="subtle"
            onClick={() => {
                window.print();
            }}
        >
            {t('print')}
        </Button>
    );
}
